export default {
    country_id: {
        value: '1',
        required: true
    },
    username: {
        value: '',
        required: true
    },
    name: {
        value: '',
        required: true
    },
    sex: {
        value: '',
        required: true
    },
    year: {
        value: '',
        required: true
    },
    mon: {
        value: '',
        required: true
    },
    day: {
        value: '',
        required: true
    },
    province: {
        value: '',
        required: true
    },
    city: {
        value: '',
        required: true
    },
    area: {
        value: '',
        required: true
    },
    zip: {
        value: '',
        required: true
    },
    address: {
        value: '',
        required: true
    },
    is_check: {
        value: false,
        required: false
    },
    province2: {
        value: '',
        required: true
    },
    city2: {
        value: '',
        required: true
    },
    area2: {
        value: '',
        required: true
    },
    zip2: {
        value: '',
        required: true
    },
    ship_addr1: {
        value: '',
        required: true
    },
    province3: {
        value: '',
        required: false
    },
    city3: {
        value: '',
        required: false
    },
    area3: {
        value: '',
        required: false
    },
    zip3: {
        value: '',
        required: false
    },
    ship_addr2: {
        value: '',
        required: false
    },
    phone: {
        value: '',
        required: false
    },
    job: {
        value: '',
        required: true
    },
    mobile: {
        value: '',
        required: true
    },
    email: {
        value: '',
        required: false
    },
    height: {
        value: '',
        required: false
    },
    weight: {
        value: '',
        required: false
    },
    pants_length: {
        value: '',
        required: false
    },
    has_child: {
        value: '',
        required: false
    },
    used_ind: {
        value: '',
        required: false
    },
    love_brand: {
        value: '',
        required: false
    },
}